<template>
  <form class="flex column justify-space-between form">
    <label class="label">Nombre</label>
    <input type="text" v-model="name" />
    <label class="label">Correo</label>
    <input type="text" v-model="email" />
    <label class="label">RFC</label>
    <input type="text" v-model="rfc" />
    <div class="flex justify-space-evenly">
      <button @click.prevent="$emit('closeForm')" class="btn cancel">
        Cancelar
      </button>
      <button @click.prevent="submitForm" class="btn">
        Guardar
      </button>
    </div>
    <ErrorModal
      @confirm="errorModalActive = false"
      :active="errorModalActive"
      message="Hubo un error"
    />
    <SuccessModal
      @confirm="confirmSuccessModal"
      :active="successModalActive"
      message="Se actualizaron de manera correcta tus datos de facturación"
    />
  </form>
</template>

<script>
import ErrorModal from '@/components/ErrorModal'
import SuccessModal from '@/components/SuccessModal'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BillingInformationForm',
  components: {
    ErrorModal,
    SuccessModal
  },
  data () {
    return {
      name: '',
      email: '',
      rfc: '',
      errorModalActive: false,
      successModalActive: false
    }
  },
  computed: {
    ...mapGetters([
      'billing_name',
      'billing_email',
      'billing_rfc'
    ])
  },
  mounted () {
    this.name = this.billing_name
    this.email = this.billing_email
    this.rfc = this.billing_rfc
  },
  methods: {
    ...mapActions('user', [
      'updateBillingInformation'
    ]),
    submitForm () {
      const data = {
        user: {
          billing_name: this.name,
          billing_rfc: this.rfc,
          billing_email: this.email
        }
      }

      this.updateBillingInformation(data).then(data => {
        this.successModalActive = true
      }).catch(_ => {
        this.errorModalActive = true
      })
    },
    confirmSuccessModal () {
      this.succesModalActive = false
      this.$emit('closeForm')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

.form {
  text-align: left;
  background-color: $white;
  border-radius: 0 2rem 2rem 0;
  width: 58%;
  padding: .25rem 1.25rem;
}

.label {
  font-size: .75rem;
  color: #989898;
}

.btn {
  font-size: 0.75rem;
  background-color: $light-blue;
  border-radius: 20px;
  color: white;
  border: 0;
  padding: 0.5rem 1rem;
  margin: 12px 0;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }

  &.cancel {
    color: $light-blue;
    background-color: white;
  }
}
</style>
